import { useMemo } from 'react';
import _ from 'lodash';

import { getIdsFromPath } from '@/utils';

const DOUBLE_SLASH = '\\';
const useGetSubsidiaryLessPath = (orgPath?: string): string => {
  const { subsidiaryId } = getIdsFromPath(orgPath);
  const subsidiaryLessOrgPath = useMemo(() => {
    if (!orgPath) {
      return '';
    }
    if (subsidiaryId) {
      const value = orgPath || '';
      const clean = _.dropRight(_.compact(value.split(DOUBLE_SLASH))).join(DOUBLE_SLASH);

      return `${DOUBLE_SLASH}${clean}${DOUBLE_SLASH}`;
    }
    return orgPath;
  }, [orgPath, subsidiaryId]);
  return subsidiaryLessOrgPath;
};
export default useGetSubsidiaryLessPath;
